import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MessageProvider } from 'src/app/providers/message.provider';

/**
 * Quando a operação é concluída mas o envio da notificação falha, o BFF devolve o texto do aviso no
 * cabeçalho X-Aviso-Mensagem (codificado como URL, UTF-8). Aqui o aviso é exibido ao usuário.
 */
@Injectable()
export class AvisoOperacaoInterceptor implements HttpInterceptor {

    static readonly CABECALHO = 'X-Aviso-Mensagem';

    // A tela costuma mostrar a própria mensagem de sucesso assim que a resposta chega, e cada toast
    // fecha o anterior. O atraso faz o aviso aparecer depois dela, em vez de ser engolido por ela.
    private static readonly ATRASO_MS = 800;
    private static readonly DURACAO_MS = 6000;

    constructor(private messageProvider: MessageProvider) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    const aviso = this.lerAviso(event);
                    if (aviso) {
                        setTimeout(() => this.messageProvider.showToast(aviso, AvisoOperacaoInterceptor.DURACAO_MS),
                            AvisoOperacaoInterceptor.ATRASO_MS);
                    }
                }
            })
        );
    }

    private lerAviso(resposta: HttpResponse<any>): string {
        const valor = resposta.headers.get(AvisoOperacaoInterceptor.CABECALHO);
        if (!valor) {
            return null;
        }
        try {
            return decodeURIComponent(valor);
        } catch (e) {
            return valor;
        }
    }
}
